import { cn } from '@/lib/utils';

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Renders `text` with all case-insensitive occurrences of `searchTerm`
 * wrapped in a <mark> element. When `searchTerm` is empty the text is
 * returned verbatim. Designed to be dropped into any existing cell renderer
 * that already uses `useDataTableSearch()`.
 */
export function TextHighlight({
  text,
  searchTerm,
  className,
}: {
  text: string;
  searchTerm: string;
  className?: string;
}): React.ReactElement {
  const trimmed = searchTerm.trim();

  if (!trimmed || !text) {
    return <>{text}</>;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(trimmed)})`, 'i'));

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark
            key={i}
            className={cn(
              'bg-yellow-200 dark:bg-yellow-800 text-inherit not-italic rounded-[2px]',
              className
            )}
          >
            {part}
          </mark>
        ) : (
          part || null
        )
      )}
    </>
  );
}
